/**
 * Handles the expand/collapse functionality of footer menus.
 * 
 * @param {NodeList|Array} menus - Collection of DOM elements representing footer menu sections
 * @returns {void}
 */
const footerMenus = menus => {
  if (!menus) return;

  menus.forEach(menu => {
    const menuButton = menu.querySelector('button');

    menuButton.addEventListener('click', () => {
      const isExpanded = menuButton.getAttribute('aria-expanded') === 'true';

      menuButton.setAttribute('aria-expanded', !isExpanded);
    });
  })
}

export default footerMenus;

